"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-reply-meta.tsx
var ReplyMeta = function ReplyMeta(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    clipPath: "url(#clip0_1278_146814)"
  }, (0, _preact.h)("path", {
    d: "M12.8 2H3.2C2.54 2 2 2.54 2 3.2V14L4.4 11.6H12.8C13.46 11.6 14 11.06 14 10.4V3.2C14 2.54 13.46 2 12.8 2Z"
  })), (0, _preact.h)("defs", null, (0, _preact.h)("clipPath", {
    id: "clip0_1278_146814"
  }, (0, _preact.h)("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))));
};

var _default = ReplyMeta;
exports.default = _default;